import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const getTicketingCatalog = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/ticketing/catalog`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return res.data.data.catalog
}

export const getTickets = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/ticketing/tickets`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return res.data.data
}

export const editTicketSetting = async ticket => {
  const token = await getToken()

  const res = await axios.post(`${getBFFUrl()}/ticketing/editTicket`, {
      ticket,
      operator: 'BALSAS',
    },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}

export const purchaseTicket = async (tickets, payload) => {
  const token = await getToken()

  const res = await axios.post(`${getBFFUrl()}/ticketing/purchaseTicket`, {
      tickets,
      payload,
      operator: 'BALSAS',
    },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data
}
